import React, { type PropsWithChildren } from 'react';

import {
  Container,
  LoadingSpinner,
  SpinnerContainer,
} from './ViewsLayout.styles';

export type ViewsLayoutProps = PropsWithChildren<{
  isLoading?: boolean;
}>;

function ViewsLayout({ children, isLoading }: ViewsLayoutProps) {
  return (
    <Container>
      {isLoading ? (
        <SpinnerContainer>
          <LoadingSpinner />
        </SpinnerContainer>
      ) : (
        children
      )}
    </Container>
  );
}

export default ViewsLayout;
